<div class="project-settings-container">
  <div class="project-settings-dialog">
    <!-- Header -->
    <div class="settings-header">
      <h1>Project Settings</h1>
      <button mat-icon-button (click)="onClose()" class="close-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Tabbed Content -->
    <div class="settings-content">
      <mat-tab-group #tabGroup class="settings-tabs" animationDuration="200ms" (selectedIndexChange)="onTabChange($event)">
        
        <!-- Plans Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>assignment</mat-icon>
            <span>Routines</span>
          </ng-template>
          <div class="tab-content">
            <app-plans 
              [projectId]="projectId"
              [currentUserId]="currentUserId"
              [currentVersion]="currentVersion"
              [canCreatePlans]="canCreatePlans"
              (addPlan)="onAddPlan()"
              (editPlan)="onEditPlan($event)"
              (deletePlan)="onDeletePlan($event)"
            ></app-plans>
          </div>
        </mat-tab>

        <!-- Secret Sources Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>source</mat-icon>
            <span>Secret Sources</span>
          </ng-template>
          <div class="tab-content">
            <app-secret-sources [projectId]="projectId"></app-secret-sources>
          </div>
        </mat-tab>

        <!-- Secrets Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>security</mat-icon>
            <span>Secrets</span>
          </ng-template>
          <div class="tab-content">
            <app-secrets #secretsComponent
              [projectId]="projectId"
              (needSecretSource)="switchToSecretSourcesTab()">
            </app-secrets>
          </div>
        </mat-tab>

        <!-- Features Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>toggle_on</mat-icon>
            <span>Features</span>
          </ng-template>
          <div class="tab-content">
            <app-features 
              [projectId]="projectId"
              (featureToggled)="onFeatureToggled($event)">
            </app-features>
          </div>
        </mat-tab>

        <!-- Connections Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>cable</mat-icon>
            <span>Connections</span>
          </ng-template>
          <div class="tab-content">
            <div class="settings-tab-header">
              <span class="settings-tab-title"
                >Connections ({{ connectionsCount() }})</span
              >
              @if (canManageConnections()) {
                <button
                  mat-button
                  class="settings-tab-add-button"
                  (click)="addConnection()"
                  aria-label="Add new connection"
                >
                  <mat-icon>add</mat-icon>
                  <span>Add Connection</span>
                </button>
              }
            </div>
            <app-connections
              [projectId]="projectId"
              [fullWidth]="true"
              (connectionsCountChange)="onConnectionsCountChange($event)">
            </app-connections>
            @if (canManageConnections()) {
              <app-storage-grants [projectId]="projectId"></app-storage-grants>
            }
          </div>
        </mat-tab>

        <!-- Modules Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>extension</mat-icon>
            <span>Modules</span>
          </ng-template>
          <div class="tab-content">
            <app-wasm-modules
              [projectId]="projectId"
              (deleteModule)="onDeleteWasmModule($event)">
            </app-wasm-modules>
          </div>
        </mat-tab>

        <!-- Push Destinations Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>notifications_active</mat-icon>
            <span>Push Destinations</span>
          </ng-template>
          <div class="tab-content">
            <div class="settings-tab-header">
              <span class="settings-tab-title"
                >Push Destinations ({{ pushDestinationsCount() }})</span
              >
              <button
                mat-button
                class="settings-tab-add-button"
                (click)="addPushDestination()"
                aria-label="Add new push destination"
              >
                <mat-icon>add</mat-icon>
                <span>Add Destination</span>
              </button>
            </div>
            <app-push-destinations
              [projectId]="projectId"
              (destinationsCountChange)="onPushDestinationsCountChange($event)">
            </app-push-destinations>
          </div>
        </mat-tab>

        <!-- Access Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>key</mat-icon>
            <span>Access</span>
          </ng-template>
          <div class="tab-content">
            <app-project-access
              [projectId]="projectId!"
              [versionId]="currentVersion?.versionId ?? null"
              [canAdminister]="canAdministerAccess">
            </app-project-access>
          </div>
        </mat-tab>

      </mat-tab-group>
    </div>
  </div>
</div> 
